import { CommandProps } from '@tiptap/core';

import { canInsertLandscapeSection } from './canInsertLandscapeSection';
import { sectionManagerKey, TSectionMeta } from '../SectionNode';

/**
 * Insert a new landscape section at the current cursor position.
 *
 * The section is inserted after the current top-level block,
 * similar to how images and tables are inserted.
 *
 * Returns false if the cursor is in an invalid position (inside table, list, etc.)
 */
const insertLandscapeSectionCommand =
  () =>
  ({ editor, state, chain }: CommandProps) => {
    // Check if we can insert at the current position
    if (!canInsertLandscapeSection(editor)) {
      return false;
    }

    const { $from } = state.selection;

    // Find the position after the current top-level block
    // depth 1 = direct children of the document
    // Safe: canInsertLandscapeSection ensures $from.depth >= 1 before we reach here
    const endOfBlock = $from.after(1);

    return chain()
      .command(({ tr }) => {
        // Set delta meta for O(1) section count update
        tr.setMeta(sectionManagerKey, { delta: 1 } as TSectionMeta);
        return true;
      })
      .insertContentAt(endOfBlock, {
        type: 'section',
        content: [{ type: 'paragraph' }],
      })
      .focus()
      .run();
  };

export default insertLandscapeSectionCommand;
